<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Working Experience"
      text="Update working experiences"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="localWorkingExperience.company_name"
                v-validate="'required'"
                outlined
                :class="{
                  'required':!localWorkingExperience.company_name
                }"
                :error-messages="errors.collect('company_name')"
                data-vv-name="company_name"    
                data-vv-as="previous company"
                label="Previous Company"
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="localWorkingExperience.occupation"
                label="Occupation"
                outlined
              />
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDateDisplay"
                    v-validate="'required'"
                    :error-messages="errors.collect('startDateDisplay')" 
                    data-vv-name="startDateDisplay"
                    label="Start Date"
                    readonly
                    outlined
                    data-vv-as="start date"  
                    class="label-position"   
                    :class="{
                      'required':!startDateDisplay
                    }"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localWorkingExperience.start_date"
                  type="month"
                  @input="startDateMenu = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="endDateDisplay"
                    v-validate="'required'"
                    :error-messages="errors.collect('endDateDisplay')" 
                    data-vv-name="endDateDisplay"
                    label="End Date"
                    readonly
                    outlined
                    data-vv-as="end date"  
                    class="label-position"   
                    :class="{
                      'required':!endDateDisplay
                    }"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localWorkingExperience.end_date"
                  type="month"
                  @input="endDateMenu = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-textarea
                v-model="localWorkingExperience.reason"
                v-validate="'required'"
                outline
                :class="{
                  'required':!localWorkingExperience.reason
                }"
                :error-messages="errors.collect('reason')"
                label="Reason of Leaving"
                auto-grow
                data-vv-name="reason"  
                outlined
                rows="3"
                row-height="25"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      workingExperience: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localWorkingExperience: null,
        loading: false,
        occupations: [],
        startDateMenu: false,
        endDateMenu: false,
      }
    },
    computed: {
      startDateDisplay () {
        return this.localWorkingExperience.start_date ? this.$moment(this.localWorkingExperience.start_date, 'YYYY-MM-DD').format('MMM YYYY') : ''
      },
      endDateDisplay () {
        return this.localWorkingExperience.end_date ? this.$moment(this.localWorkingExperience.end_date, 'YYYY-MM-DD').format('MMM YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.localWorkingExperience = { ...this.workingExperience }

        this.loading = false
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.hrisWorkingExperiences().update(this.workingExperience.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          company_name: this.localWorkingExperience.company_name,
          start_date: this.$moment(this.localWorkingExperience.start_date + '-01', 'YYYY-MM-DD').format('YYYY-MM-DD'),
          end_date: this.$moment(this.localWorkingExperience.end_date + '-01', 'YYYY-MM-DD').format('YYYY-MM-DD'),
          reason: this.localWorkingExperience.reason,
          occupation: this.localWorkingExperience.occupation,
        }
      },
    },
  }
</script>

<style scoped>
.required >>> fieldset {
  border: 2px solid red;
}

.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white
}
</style>
